import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import './other-videos-list.scss';

export function OtherVideosList(props) {
  if (!props.videosList.length) return null;

  const { cardColumnSizeXs, cardColumnSizeMd, cardColumnSizeLg, cardColumnSizeXl, videoLinkTrackingId } = props;

  return (
    <Row className="others-videos-list mt-0_5 mt-md-1">
      {props.videosList.map(item => (
        <Col
          xs={cardColumnSizeXs}
          md={cardColumnSizeMd}
          lg={cardColumnSizeLg}
          xl={cardColumnSizeXl}
          key={item.url}
          className="mt-0_5 mt-md-1"
        >
          <a
            className="video-linkout card-link d-block bg-gray-lightest px-0_5 pb-0_5 h-100"
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            data-tracking-id={videoLinkTrackingId}
          >
            <Row>
              <Col xs={{ size: 'auto' }}>
                <div className="pt-0_5 ps-0_75 h2">
                  <span className="icon icon-play_circle_outline" aria-hidden />
                </div>
              </Col>
              <Col>
                <div className="medium mt-0_5 mb-0_25">{item.description}</div>
                <span className="small text-uppercase fw-bold">
                  watch video <span className="icon icon-new-tab" aria-hidden />
                </span>
              </Col>
            </Row>
          </a>
        </Col>
      ))}
    </Row>
  );
}

OtherVideosList.propTypes = {
  videosList: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  cardColumnSizeXs: PropTypes.string,
  cardColumnSizeMd: PropTypes.string,
  cardColumnSizeLg: PropTypes.string,
  cardColumnSizeXl: PropTypes.string,
  videoLinkTrackingId: PropTypes.string,
};

OtherVideosList.defaultProps = {
  cardColumnSizeXs: '12',
  cardColumnSizeMd: '6',
  cardColumnSizeLg: '4',
  cardColumnSizeXl: '4',
  videoLinkTrackingId: '',
};
